<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Stage & Step</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="dashboard">Home</a>
                </li>
                <li class="breadcrumb-item active">Stage & Step</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-sm-4">
            <div class="text-right">
              <button
                class="btn btn-success waves-effect mt-2 mb-2"
                @click="addNewStage"
                id="addNewSt_btn"
                type="button"
                name="stage"
                data-toggle="modal"
              >
                <i class="fas fa-plus fa-2x"></i>
              </button>
            </div>
          </div>
        </div>

        <div
          class="row justify-content-center"
          v-for="(stage, ndx01) in aStagesList"
          :key="ndx01"
        >
          <div class="table-responsive step mb-5">
            <!--Stage-->
            <table
              id="table002"
              class="table"
              style="margin-bottom: 0rem !important"
            >
              <thead class="bg-info text-center text-white">
                <tr>
                  <th style="width: 24%" class="text-white boldsizeText" id="">
                    {{ stage.stageDetail.stage.name }}
                  </th>
                  <th style="width: 15%" class="boldText">Resource</th>
                  <th style="width: 15%" class="boldText">Alerts</th>
                  <th style="width: 15%" class="boldText">SMS</th>
                  <th style="width: 15%" class="boldText">Email</th>
                  <th style="width: 15%" class="boldText">
                    <a
                      class="btn-floating btn-sm btn-success up StageOrder"
                      style="font-size: 1.5rem !important"
                      ><i
                        class="fas fa-arrow-up text-white"
                        @click="stageUpDownArrowClick(ndx01, 'up')"
                      ></i
                    ></a>
                    <a
                      class="btn-floating btn-sm btn-success down StageOrder"
                      style="font-size: 1.5rem !important"
                      id="down"
                      ><i
                        class="fas fa-arrow-down text-white"
                        @click="stageUpDownArrowClick(ndx01, 'down')"
                      ></i
                    ></a>
                  </th>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr class="bg-grey">
                  <td class="text-center trSpacing">
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-success button-align-small"
                        :disabled="updButton == 0"
                        @click="
                          editStage(stage.stageDetail.stage.stageId, ndx01)
                        "
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        class="
                          btn btn-success
                          dropdown-toggle dropdown-toggle-split
                        "
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        :disabled="delButton == 0"
                      >
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>
                      <div class="dropdown-menu animated flipInY">
                        <a
                          @click="
                            archiveStageClick_1(stage.stageDetail.stage.stageId)
                          "
                          class="dropdown-item"
                          id="sandsArchiveV2"
                          >Archive</a
                        >
                      </div>
                    </div>
                  </td>
                  <td class="text-center trSpacing">
                    <span
                      class="button-align button-align-small"
                      v-for="(res, ndx05) in stage.stageDetail.res"
                      :key="ndx05"
                    >
                      <span
                        :class="classObjectStageRes(res)"
                        id=""
                        v-if="res.name.length > 0"
                        class=""
                        >{{ res.name.slice(0, 8) + "..." }}
                      </span>
                      <br />
                      <br />
                    </span>
                  </td>
                  <td class="text-center trSpacing">
                    <span>
                      <span
                        id=""
                        v-if="
                          textObjectStageAlert(stage.stageDetail.stage) !== ''
                        "
                        :class="classObjectStageAlert(stage.stageDetail.stage)"
                        >{{
                          textObjectStageAlert(stage.stageDetail.stage)
                        }}</span
                      ></span
                    >
                  </td>
                  <td class="text-center trSpacing">
                    <span
                      v-for="(sms, ndx05) in stage.stageDetail.sms"
                      :key="ndx05"
                    >
                      <span
                        class="bs-label label-success badgeBorder"
                        id=""
                        v-if="sms.name.length > 0"
                        >{{ sms.name.slice(0, 8) + "..." }}
                      </span>
                      <br />
                      <br />
                    </span>
                  </td>
                  <td class="text-center trSpacing">
                    <span
                      v-for="(email, ndx05) in stage.stageDetail.email"
                      :key="ndx05"
                    >
                      <span
                        class="bs-label label-success badgeBorder"
                        id=""
                        v-if="email.name.length > 0"
                        >{{ email.name.slice(0, 8) + "..." }}
                      </span>
                      <br />
                      <br />
                    </span>
                  </td>
                  <td class="trSpacing text-left button-align-small">&nbsp;</td>
                </tr>
                <td class="trSpacing">&nbsp;</td>
                <tr class="" v-for="(val, ndx) in stage.steps" :key="ndx">
                  <th class="boldText" id="">
                    <span v-if="val.step.isDeleted == 1" style="color: red">
                      {{ val.step.name }}
                    </span>
                    <span v-else> {{ val.step.name }} </span>
                  </th>
                  <td class="text-center trSpacing">
                    <span v-for="(res, ndx_1) in val.res" :key="ndx_1">
                      <span
                        :class="classObjectStageRes(res)"
                        v-if="res.isDeleted == 1"
                        class="bs-label label-danger badgeBorder"
                        >{{ res.name.slice(0, 8) + "..." }}
                      </span>
                      <span
                        :class="classObjectStageRes(res)"
                        v-else-if="
                          res.name.length > 0 && res.isReleased == false
                        "
                        >{{ res.name.slice(0, 8) + "..." }}
                      </span>
                      <span
                        id=""
                        v-else
                        class="bs-label label-danger badgeBorder"
                        >{{ res.name.slice(0, 8) + "..." }}
                      </span>
                      <br />
                      <br />
                    </span>
                  </td>
                  <td class="text-center trSpacing">
                    <span
                      v-if="
                        (val.step.alertHours != 0 ||
                          val.step.alertMins != 0 ||
                          val.step.alertDays != 0) &&
                        val.step.isDeleted == 1
                      "
                      class="bs-label label-danger badgeBorder"
                      ><span id="">{{ textObjectStageAlert(val.step) }}</span>
                    </span>
                    <span
                      v-else-if="
                        val.step.alertHours != 0 ||
                        val.step.alertMins != 0 ||
                        val.step.alertDays != 0
                      "
                      class="bs-label label-success badgeBorder"
                      ><span id="">{{ textObjectStageAlert(val.step) }}</span>
                    </span>
                  </td>
                  <td class="text-center trSpacing button-align-small">
                    <span v-for="(sms, ndx_44) in val.sms" :key="ndx_44">
                      <span
                        v-if="sms.isDeleted == 1"
                        class="bs-label label-danger badgeBorder"
                        id=""
                        >{{ sms.name.slice(0, 8) + "..." }}
                      </span>
                      <span
                        v-else
                        class="bs-label label-success badgeBorder"
                        id=""
                        >{{ sms.name.slice(0, 8) + "..." }}
                      </span>
                      <br />
                      <br />
                    </span>
                  </td>
                  <td class="text-center trSpacing button-align-small">
                    <span v-for="(email, ndx_4) in val.email" :key="ndx_4">
                      <span
                        v-if="email.isDeleted == 1"
                        class="bs-label label-danger badgeBorder"
                        id=""
                        >{{ email.name.slice(0, 8) + "..." }}
                      </span>
                      <span
                        v-else
                        class="bs-label label-success badgeBorder"
                        id=""
                        >{{ email.name.slice(0, 8) + "..." }}
                      </span>
                      <br />
                      <br />
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <!--Stage-->
          </div>
        </div>

        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->

    <!-- Update Stage Modal *99* -->

    <div
      class="modal fade"
      id="addStage"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none; z-index: 900"
    >
      <div class="modal-dialog cascading-modal modal-lg">
        <div class="modal-content" style="width: 130% !important">
          <div class="modal-header">
            <h4 class="modal-title" style="" id="myLargeModalLabel">
              Update Stage and Steps
            </h4>
            <button
              style="margin-left: 20px"
              class="btn btn-outline-success waves-effect col-8 m-r-10"
              @click="updateStageClick()"
              id="UpdSt_btn"
            >
              Update Stage
            </button>
            <button
              class="btn btn-success m-r-10"
              @click="addNewStep()"
              type="button"
              id="StagenameInput"
            >
              <i class="fa fa-plus"></i>
            </button>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
              @click="closeButton()"
            >
              ×
            </button>
          </div>

          <div class="modal-body mb-1 pt-2">
            <div class="vtabs customvtab">
              <ul
                class="nav nav-tabs tabs-vertical"
                role="tablist"
                id="step-tabs"
              >
                <li class="nav-item fixed">
                  <a
                    id="a123"
                    class="nav-link active"
                    data-toggle="tab"
                    href="#stage01"
                    role="tab"
                  >
                    <div class="b" style="margin-left: 0px; margin-top: 0px">
                      <span class="hidden-xs-down boldText">{{
                        aSingleStage.stageDetail.stage.name
                      }}</span>
                    </div>
                  </a>
                </li>
                <li
                  class="nav-item step"
                  v-for="(step, ndx02) in aSingleStage.steps"
                  :key="ndx02"
                >
                  <a
                    class="nav-link"
                    :id="'navlink'+step.step.stepId"
                    data-toggle="tab"
                    href="#step01"
                    role="tab"
                    @click="stepNameClick(ndx02,step.step.stepId)"
                  >
                    <span class="hidden-xs-down">
                      <span
                        class="btn-floating btn-sm btn-success up"
                        @click="stepUpDownArrowClick(ndx02, 'up')"
                        ><i class="fas fa-arrow-up white-text"></i
                      ></span>
                      &nbsp;
                      <span
                        class="btn-floating btn-sm btn-success down"
                        id="down"
                        @click="stepUpDownArrowClick(ndx02, 'down')"
                        ><i class="fas fa-arrow-down white-text"></i
                      ></span>
                      &nbsp;
                      <span>
                        <div class="b">
                          <span
                            :style="
                              step.step.isDeleted == 0 ? '' : 'color: red'
                            "
                            :id="'step-' + ndx02"
                          >
                            {{ step.step.name }}
                          </span>
                        </div>
                      </span>
                      <!-- <div v-else>
                        <div style="color: red" :id="'step-' + ndx02">
                          {{ step.step.name }}
                        </div>
                      </div> -->
                      <!-- </div> -->
                    </span>
                  </a>
                </li>
              </ul>
              <!-- Tab panes -->
              <div class="tab-content">
                <div class="tab-pane active" id="stage01" role="tabpanel">
                  <div class="row">
                    <button
                      class="btn btn-outline-danger waves-effect col-2"
                      id="sandsArchive1"
                      @click="archiveStageClick"
                    >
                      Archive
                    </button>
                  </div>

                  <div class="modal-body">
                    <h3 class="font-weight-bold h3Spacing">Stage Name</h3>
                    <form class="floating-labels">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="form-group m-b-40">
                            <input
                              type="text"
                              class="form-control"
                              id=""
                              placeholder=""
                              maxlength="30"
                            
                              v-model="aSingleStage.stageDetail.stage.name"
                            /><span class="bar"></span>
                            <!-- <label for="">Stage Name</label> -->
                          </div>
                        </div>
                      </div>
                    </form>
                    <!-- Task to do Multiselect  -->
                    <h3 class="font-weight-bold h3Spacing">Task To-do</h3>
                    <form class="floating-labels">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="form-group m-b-40">
                            <Multiselect
                            v-model="selectedTasks"
                            mode="tags"
                            :searchable="true"
                            :createTag="true"
                            :options="taskList"                         
                           /><span class="bar"></span>
                            <!-- <label for="">Stage Name</label> -->
                          </div>
                        </div>
                      </div>
                    </form>
                     <!-- Task to do Multiselect  -->
                      
                    <h3 class="font-weight-bold h3Spacing">
                      Resource
                      <span class="subText">
                        <a href="javascript:void(0)" class="mytooltip">
                          <i class="fas fa-exclamation-circle fa-sm"></i>
                          <span class="tooltip-content5">
                            <span class="tooltip-text3">
                              <span class="tooltip-inner2">
                                <div class="timeline-panel">
                                  <div class="timeline-body">
                                    <p>
                                      Capture or release resources when record
                                      enters stage
                                    </p>
                                  </div>
                                </div>
                              </span>
                            </span>
                          </span>
                        </a>
                      </span>
                    </h3>
                    <div id="education_fields"></div>
                    <form class="floating-labels">
                      <!-- first row -->
                      <div v-if="ress.length < 1">
                        <h5 style="color: red">No resources available</h5>
                        <br />
                      </div>
                      <div v-else>
                        <div
                          class="row"
                          v-for="(resArr, ndx04) in selectedResArr"
                          :key="ndx04"
                        >
                          <div class="col-lg-6">
                            <div class="form-group">                              
                              <Dropdown
                                :showClear='true'
                                filterMatchMode="startsWith"
                                v-model="resArr.resourceId"
                                :options="ress"
                                optionLabel="name"
                                optionValue="resourceId"
                                placeholder="Select a Resource"
                                :filter="true"
                                filterPlaceholder="Find Resource"
                                appendTo="self"
                                class="col-12"                                
                                @change="selectedStageResArrChanged(resArr,ndx04)"
                              />                             
                            </div>
                          </div>
                          <div class="col-lg-2 switchery-demo">
                            <p
                              class="font-weight-bolder"
                              style="margin: 0px !important"
                            >
                              Capture
                            </p>
                            <label class="switch" style="top: 25px !important">
                              <input
                                id="capture1"
                                type="checkbox"
                                :v-bind="resArr.isCaptured"                                
                                :disabled="resArr.isReleased == true || resArr.resourceId ==0"
                                v-model="resArr.isCaptured"
                              />
                              <span class="slider v2"></span>
                            </label>
                          </div>
                          <div class="col-lg-2 switchery-demo">
                            <p
                              class="font-weight-bolder"
                              style="margin: 0px !important"
                            >
                              Release
                            </p>
                            <label class="switch" style="top: 25px !important">
                              <input
                                id="released"
                                type="checkbox"
                                @change="autoDisabledRelease(resArr.isReleased)"
                                :disabled="resArr.isCaptured == true || resArr.resourceId ==0"
                                v-model="resArr.isReleased"
                              />
                              <span class="sliderV2 v2"></span>
                            </label>
                          </div>
                        <div
                          class="col-lg-2 switchery-demo"
                          style="margin-top: 2px"
                        >
                          <div
                            v-if="ndx04 == selectedResArr.length - 1">
                          <button
                            class="btn btn-success addResource"
                            type="button"
                            @click="addResToList"
                          >
                            <i class="fa fa-plus"></i>
                          </button>
                          <button
                            class="btn btn-danger addResource"
                            type="button"
                            style="margin-left: 50%;"
                            @click="removeResToList(ndx04)"                              
                          >
                            <i class="fa fa-minus"></i>
                          </button>
                          </div>
                          <div v-else>
                          <button
                            class="btn btn-danger addResource"
                            type="button"
                            @click="removeResToList(ndx04)"                              
                          >
                            <i class="fa fa-minus"></i>
                          </button>
                          </div>
                        </div>
                        </div>
                      </div>
                      <!-- first row -->

                      <h3 class="font-weight-bold h3Spacing">
                        Alerts
                        <span class="subText">
                          <a href="javascript:void(0)" class="mytooltip">
                            <i class="fas fa-exclamation-circle fa-sm"></i>
                            <span class="tooltip-content5">
                              <span class="tooltip-text3">
                                <span class="tooltip-inner2">
                                  <div class="timeline-panel">
                                    <div class="timeline-body">
                                      <p>
                                        Alert triggered if record still in
                                        stage, based on Stage Time In
                                      </p>
                                    </div>
                                  </div>
                                </span>
                              </span>
                            </span>
                          </a>
                        </span>
                      </h3>
                      <!-- third row -->
                      <div class="row">
                        <div class="col-lg-4">
                          <div class="form-group">
                            <p class="font-weight-bolder">Minutes</p>
                            <input
                              v-model="aSingleStage.stageDetail.stage.alertMins"
                              class="vertical-spin"
                              type="number"
                              data-bts-button-down-class="btn btn-secondary btn-outline"
                              data-bts-button-up-class="btn btn-secondary btn-outline"
                              name="vertical-spin"
                              style="z-index: 0 !important"
                          
                            />
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <div class="form-group">
                            <p class="font-weight-bolder">Hours</p>
                            <input
                              class="vertical-spin"
                              type="number"
                              data-bts-button-down-class="btn btn-secondary btn-outline"
                              data-bts-button-up-class="btn btn-secondary btn-outline"
                              name="vertical-spin"
                              v-model="
                                aSingleStage.stageDetail.stage.alertHours
                              "
                         
                            />
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <div class="form-group">
                            <p class="font-weight-bolder">Days</p>
                            <input
                              class="vertical-spin"
                              type="number"
                              data-bts-button-down-class="btn btn-secondary btn-outline"
                              data-bts-button-up-class="btn btn-secondary btn-outline"
                              name="vertical-spin"
                              v-model="aSingleStage.stageDetail.stage.alertDays"
                          
                            />
                          </div>
                        </div>
                      </div>
                      <!-- third row -->

                      <!-- fifth row -->
                      <div class="row">
                        <div class="col">
                          <h3 class="font-weight-bold h3Spacing">
                            SMS
                            <span class="subText">
                              <a href="javascript:void(0)" class="mytooltip">
                                <i class="fas fa-exclamation-circle fa-sm"></i>
                                <span class="tooltip-content5">
                                  <span class="tooltip-text3">
                                    <span class="tooltip-inner2">
                                      <div class="timeline-panel">
                                        <div class="timeline-body">
                                          <p>
                                            SMS sent after record enters stage
                                          </p>
                                        </div>
                                      </div>
                                    </span>
                                  </span>
                                </span>
                              </a>
                            </span>
                          </h3>

                          <Multiselect
                            v-model="smsSelected"
                            mode="tags"
                            :searchable="true"
                            :createTag="true"
                            :options="smsList"
                         
                          />
                        </div>

                        <div class="col">
                          <h3 class="font-weight-bold h3Spacing">
                            Email
                            <span class="subText">
                              <a href="javascript:void(0)" class="mytooltip">
                                <i class="fas fa-exclamation-circle fa-sm"></i>
                                <span class="tooltip-content5">
                                  <span class="tooltip-text3">
                                    <span class="tooltip-inner2">
                                      <div class="timeline-panel">
                                        <div class="timeline-body">
                                          <p>Email sent after entering stage</p>
                                        </div>
                                      </div>
                                    </span>
                                  </span>
                                </span>
                              </a>
                            </span>
                          </h3>

                          <Multiselect
                            v-model="emailSelected"
                            mode="tags"
                            :searchable="true"
                            :createTag="true"
                            :options="emailList"
                          
                          />
                        </div>
                      </div>
                      <!-- fifth row *88* -->
                    </form>
                  </div>
                </div>
                <div class="tab-pane" id="step01" role="tabpanel">
                  <div class="row">
                    <!-- <button
                      class="btn btn-outline-success waves-effect col-9 m-r-10"
                      @click="addUpdateStep(0)"
                    >
                      Update Step
                    </button> -->
                    <button
                      v-if="aSingleStep.step.isDeleted == 0"
                      class="btn btn-outline-danger waves-effect col-2"
                      id="sandsArchiveV3"
                      @click="stepArchiveClick"
                    >
                      Archive
                    </button>
                    <button
                      v-else-if="aSingleStep.step.isDeleted == 1"
                      class="btn btn-outline-success waves-effect col-2"
                      id="sandsArchiveV3"
                      @click="stepActivateClick"
                    >
                      Activate
                    </button>
                  </div>

                  <div class="modal-body">
                    <h3 class="font-weight-bold h3Spacing">Step Name</h3>
                    <form class="floating-labels">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="form-group m-b-40">
                            <input
                              type="text"
                              class="form-control"
                              id=""
                              placeholder=""
                              maxlength="30"
                              @keypress="EnterName()"
                              v-model="aSingleStep.step.name"
                            /><span class="bar"></span>
                            <!-- <label for="">Step Name</label> -->
                          </div>
                        </div>
                      </div>
                    </form>
                     <!-- Task to do Multiselect  -->
                    <h3 class="font-weight-bold h3Spacing">Task To-do</h3>
                    <form class="floating-labels">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="form-group m-b-40">
                            <Multiselect
                            v-model="aSingleStep.selectedTasks"
                            mode="tags"
                            :searchable="true"
                            :createTag="true"
                            :options="taskList"                         
                           /><span class="bar"></span>
                            <!-- <label for="">Stage Name</label> -->
                          </div>
                        </div>
                      </div>
                    </form>
                     <!-- Task to do Multiselect  -->

                    <h3 class="font-weight-bold h3Spacing">
                      Resource
                      <span class="subText">
                        <a href="javascript:void(0)" class="mytooltip">
                          <i class="fas fa-exclamation-circle fa-sm"></i>
                          <span class="tooltip-content5">
                            <span class="tooltip-text3">
                              <span class="tooltip-inner2">
                                <div class="timeline-panel">
                                  <div class="timeline-body">
                                    <p>
                                      Capture or release resources when step is
                                      acknowledged
                                    </p>
                                  </div>
                                </div>
                              </span>
                            </span>
                          </span>
                        </a>
                      </span>
                    </h3>
                    <div id="step_fields1"></div>
                    <form class="floating-labels">
                      <!-- first row *77*-->

                      <div
                        class="row"
                        v-for="(resArr1, ndx06) in aSingleStep.resSelected"
                        :key="ndx06"
                      >
                        <div class="col-lg-6">
                          <div class="form-group">
                            <Dropdown
                              :showClear='true'
                              v-model="resArr1.resourceId"  
                              :options="ress"
                              optionLabel="name"
                              optionValue="resourceId"
                              placeholder="Select a Resource"
                              :filter="true"
                              filterPlaceholder="Find Resource"
                              appendTo="self"
                              class="col-12"
                              @change="selectedStepResArrChanged(resArr1,ndx06)"
                            />
                          </div>
                        </div>
                        <div class="col-lg-2 switchery-demo">
                          <p
                            class="font-weight-bolder"
                            style="margin: 0px !important"
                          >
                            Capture
                          </p>
                          <label class="switch" style="top: 25px !important">
                            <input
                              id="capture11"
                              type="checkbox"
                              :v-bind="resArr1.isCaptured"
                              @change="autoDisabledCapture1(resArr1.isCaptured)"
                              :disabled="resArr1.isReleased == true || resArr1.resourceId == 0"
                              v-model="resArr1.isCaptured"
                            />
                            <span class="slider v2"></span>
                          </label>
                        </div>

                        <div
                          class="col-lg-2 switchery-demo"
                          style="margin-top: 0px"
                        >
                          <p
                            class="font-weight-bolder"
                            style="margin-top: 0px; important"
                          >
                            Release
                          </p>
                          <label class="switch" style="top: 25px !important">
                            <input
                              id="released1"
                              type="checkbox"
                              @change="autoDisabledRelease1(resArr1.isReleased)"
                              :disabled="resArr1.isCaptured == true || resArr1.resourceId == 0"
                              v-bind="resArr1.isReleased"
                              v-model="resArr1.isReleased"
                            />
                            <span class="sliderV2 v2"></span>
                          </label>
                        </div>
                        <div
                          class="col-lg-2 switchery-demo"
                          style="margin-top: 2px"
                        > 
                        <div v-if="ndx06 == aSingleStep.resSelected.length - 1">
                            <button
                            class="btn btn-success addResource"
                            type="button"
                            @click="addResToStep"
                            style="margin-top: 0px"
                            >
                            <i class="fa fa-plus"></i>
                            </button>
                             <button
                              class="btn btn-danger addResource"
                              type="button"
                              @click="removeResToStep(ndx06)"
                              style="margin-top: 0px;margin-left:50%"
                            >
                             <i class="fa fa-minus"></i>
                            </button>
                          </div>
                          <div v-else>
                            <button
                              class="btn btn-danger addResource"
                              type="button"
                              @click="removeResToStep(ndx06)"
                              style="margin-top: 0px"
                            >
                             <i class="fa fa-minus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- first row -->

                      <h3 class="font-weight-bold h3Spacing">
                        Alerts
                        <span class="subText">
                          <a href="javascript:void(0)" class="mytooltip">
                            <i class="fas fa-exclamation-circle fa-sm"></i>
                            <span class="tooltip-content5">
                              <span class="tooltip-text3">
                                <span class="tooltip-inner2">
                                  <div class="timeline-panel">
                                    <div class="timeline-body">
                                      <p>
                                        Alert triggered when step not
                                        acknowledged based on step Time In
                                      </p>
                                    </div>
                                  </div>
                                </span>
                              </span>
                            </span>
                          </a>
                        </span>
                      </h3>

                      <!-- third row -->
                      <div class="row">
                        <div class="col-lg-4">
                          <div class="form-group">
                            <p class="font-weight-bolder">Minutes</p>
                            <input
                              v-model="aSingleStep.step.alertMins"
                              class="vertical-spin"
                              type="number"
                              data-bts-button-down-class="btn btn-secondary btn-outline"
                              data-bts-button-up-class="btn btn-secondary btn-outline"
                              name="vertical-spin"
                              style="z-index: 0 !important"
                              @keypress="EnterName()"
                            />
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <div class="form-group">
                            <p class="font-weight-bolder">Hours</p>
                            <input
                              class="vertical-spin"
                              type="number"
                              data-bts-button-down-class="btn btn-secondary btn-outline"
                              data-bts-button-up-class="btn btn-secondary btn-outline"
                              name="vertical-spin"
                              v-model="aSingleStep.step.alertHours"
                              @keypress="EnterName()"
                            />
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <div class="form-group">
                            <p class="font-weight-bolder">Days</p>
                            <input
                              class="vertical-spin"
                              type="number"
                              data-bts-button-down-class="btn btn-secondary btn-outline"
                              data-bts-button-up-class="btn btn-secondary btn-outline"
                              name="vertical-spin"
                              v-model="aSingleStep.step.alertDays"
                              @keypress="EnterName()"
                            />
                          </div>
                        </div>
                      </div>
                      <!-- third row *7777*-->

                      <!-- fifth row -->
                      <div class="row">
                        <div class="col">
                          <h3 class="font-weight-bold h3Spacing">
                            SMS
                            <span class="subText">
                              <a href="javascript:void(0)" class="mytooltip">
                                <i class="fas fa-exclamation-circle fa-sm"></i>
                                <span class="tooltip-content5">
                                  <span class="tooltip-text3">
                                    <span class="tooltip-inner2">
                                      <div class="timeline-panel">
                                        <div class="timeline-body">
                                          <p>
                                            SMS sent after record enters stage
                                          </p>
                                        </div>
                                      </div>
                                    </span>
                                  </span>
                                </span>
                              </a>
                            </span>
                          </h3>

                          <Multiselect
                            v-model="aSingleStep.smsSelected"
                            mode="tags"
                            :searchable="true"
                            :createTag="true"
                            :options="smsList"
                            @change="MultiSelectListChanged()"
                          />
                        </div>

                        <div class="col">
                          <h3 class="font-weight-bold h3Spacing">
                            Email
                            <span class="subText">
                              <a href="javascript:void(0)" class="mytooltip">
                                <i class="fas fa-exclamation-circle fa-sm"></i>
                                <span class="tooltip-content5">
                                  <span class="tooltip-text3">
                                    <span class="tooltip-inner2">
                                      <div class="timeline-panel">
                                        <div class="timeline-body">
                                          <p>Email sent after entering stage</p>
                                        </div>
                                      </div>
                                    </span>
                                  </span>
                                </span>
                              </a>
                            </span>
                          </h3>

                          <Multiselect
                            v-model="aSingleStep.emailSelected"
                            mode="tags"
                            :searchable="true"
                            :createTag="true"
                            :options="emailList"
                            @change="MultiSelectListChanged()"
                          />
                        </div>
                      </div>
                      <!-- fifth row *88* -->
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- Update Stage Modal -->
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import Multiselect from "@vueform/multiselect";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
// import VueNextSelect from 'vue-next-select'
//import "vue-next-select/dist/index.min.css";

export default {
  name: "StageAndSteps",
  components: {
    Multiselect,
    // 'vue-select': VueNextSelect,
  },

  data() {
    return {
      asda: null,
      countries: [
        { title: "Old Man's War" },
        { title: "The Lock Artist" },
        { title: "HTML5" },
        { title: "Right Ho Jeeves" },
        { title: "The Code of the Wooster" },
        { title: "Thank You Jeeves" },
      ],
      previousNdx:0,
      dataChange: false,
      taskList: [],
      selectedTasks:[],
      display: true,
      EmployeeRolesStr: [],
      updButton: 1,
      delButton: 1,

      //for StageStep
      stepCount: 0,
      count: 0,
      nDelete: 0,

      //loader
      loader: "",
      //Timer
      TimerObject: {},
      aStagesList: "",
      aSingleStage: {
        stageDetail: {
          stage: {
            name: "",
          },
          steps: "",
        },
      },
      aSingleStep: {
        step: {
          name: "",
        },
      },

      selectedResObj: {
        srNo: 2,
        resourceId: 0,
        isCaptured: false,
        isReleased: false,
      },

      editStageId: -1,
      editStepIndex: -1,

      ress: "",
      smss: "",
      emails: "",

      smsList: [],
      smsSelected: [],

      emailList: [],
      emailSelected: [],

      selectedResArr: [],
      selectedResArrBak: [],
      myData: "",
      tmp: {},
      changeValue: 0,
    };
  }, // data

  //*000*
  methods: {
    //autoDisabled
    HeaderForDialog() {
      var header =
        ' <div class="modal-header">' +
        '<h4 class="modal-title" style="" id="myLargeModalLabel">' +
        "Update Stage and Steps" +
        "</h4>" +
        "<button" +
        'style="margin-left: 20px"' +
        'class="btn btn-outline-success waves-effect col-8 m-r-10"' +
        '@click="updateStageClick"' +
        'id="UpdSt_btn"' +
        ">" +
        "Update Stage" +
        "</button>" +
        "<button" +
        'class="btn btn-success m-r-10"' +
        '@click="addNewStep"' +
        'type="button"' +
        'id="StagenameInput"' +
        ">";
      ('<i class="fa fa-plus"></i>');
      ("</button>");
      ("<button");
      ('type="button"');
      ('class="close"');
      ('data-dismiss="modal"');
      ('aria-hidden="true"');
      (">");
      ("×");
      ("</button>");
      ("</div>");
      return header;
    },

    autoDisabledCapture(val) {
      //alert("Capture");
      this.dataChanged = true;
      // if (val == true) {
      //   $("#released").prop("disabled", true);
      // } else {
      //   $("#released").prop("disabled", false);
      // }
    },

    autoDisabledRelease(val) {
      //alert("Release ");
      this.dataChanged = true;
      // if (val == true) {
      //   $("#capture1").prop("disabled", true);
      // } else {
      //   $("#capture1").prop("disabled", false);
      // }
    },

    autoDisabledCapture1(val) {
      // alert("Capture 1");
      this.dataChanged = true;
      // if (val == true) {
      //   $("#released1").prop("disabled", true);
      // } else {
      //   $("#released1").prop("disabled", false);
      // }
    },

    autoDisabledRelease1(val) {
      // alert("release 1");
      this.dataChanged = true;
      // if (val == true) {
      //   $("#capture11").prop("disabled", true);
      // } else {
      //   $("#capture11").prop("disabled", false);
      // }
    },

    chkResourceName009(name) {
      //alert(name);
      if (typeof name == "undefined") return false;
      name = name.trim();
      if (name.length < 1) return false;
      return true;
    },

    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

    handleRole() {
      this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
      this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
      if (this.EmployeeRolesStr.length > 0) {
        this.val = this.EmployeeRolesStr.filter(
          (i) => i.name == "Stage and Step"
        );
        if (this.val[0].canUpdate == 0) {
          this.updButton = 0;
        }
        if (this.val[0].canDelete == 0) {
          this.delButton = 0;
        }
        if (this.val[0].canCreate == 0) {
          $("button[name=stage]").hide();
        }
      }
    },

    stepActivateClick() {
      const vm = this;

      Swal.fire({
        title: "Are you sure?",
        showConfirmButton: false,
        showDenyButton: true,
        showCancelButton: true,
        denyButtonText: "Yes, Activate it!",
      }).then((result) => {
        if (result.isDenied) {
          vm.intDummyComm();
          vm.dummyComm.extras1 = "StageStep";
          vm.dummyComm.extras =
            vm.aSingleStage.stageDetail.stage.stageId +
            vm.UKEY +
            vm.aSingleStep.step.stepId +
            vm.UKEY;
          const url = vm.SERVER + "/VNSPRAAPI/Stages/ActStp";
          vm.axiosGetData(url, 7);
        }
      });
    },

    stepArchiveClick() {
      this.count = 0;
      this.Delete = 0;
      this.nDelete = 0;
      for (let i = 0; i < this.stepCount; i++) {
        if (this.aSingleStage.steps[i].step.isDeleted == 1) {
          this.Delete++;
        } else {
          this.nDelete++;
        }
      }

      if (this.nDelete == 1) {
        this.ShowWarning("Stage must have one Step activated");
        return;
      }

      const vm = this;
      Swal.fire({
        title: "Are you sure?",
        showConfirmButton: false,
        showDenyButton: true,
        showCancelButton: true,
        denyButtonText: "Yes, Archive it!",
      }).then((result) => {
        if (result.isDenied) {
          vm.intDummyComm();
          vm.dummyComm.extras1 = "StageStep";
          vm.dummyComm.extras =
            vm.aSingleStage.stageDetail.stage.stageId +
            vm.UKEY +
            vm.aSingleStep.step.stepId +
            vm.UKEY;
          const url = vm.SERVER + "/VNSPRAAPI/Stages/ArcStp";
          vm.axiosGetData(url, 6);
        }
      });
    },

    removeResToStep(ndx) {
        // alert("remove resource");
      if(this.aSingleStep.resSelected.length==1)
      {
        return;
      }
      this.dataChanged =true;
      this.aSingleStep.resSelected.splice(ndx, 1);
    },

    addResToStep() {
      //alert("add resource");
      this.dataChanged =true;
      const x = {
        srNo: 1,
        resourceId: 0,
        isCaptured: false,
        isReleased: false,
      };
      this.aSingleStep.resSelected.push(x);
    },

    stepNameClick(ndx,StepId) {
      //alert(StepId);
      if(this.dataChanged === true)
      {
        Swal.fire({
          title: 'Current Changes will be lost. Either countinue or Please Save ',
          showDenyButton: true,
          confirmButtonText: 'countinue',
          denyButtonText: `Stay`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
             this.dataChanged=false;
             this.stepNameClick(ndx,this.aSingleStep.step.stepId);
          } else if (result.isDenied) {
           //debugger
            $('#navlink'+StepId).removeClass('active');
             $('#navlink'+this.aSingleStep.step.stepId).addClass('active');
            return;
          }
      });
        return;
      }
      this.editStepIndex = ndx;
      this.aSingleStep = JSON.parse(
        JSON.stringify(this.aSingleStage.steps[ndx])
      );

      this.aSingleStep.smsSelected = [];
      this.aSingleStep.emailSelected = [];
      this.aSingleStep.resSelected = [];
      this.aSingleStep.selectedTasks = [];
      const obj = this.aSingleStep;
      for (let i = 0; i < obj.sms.length; i++)
        obj.smsSelected.push(obj.sms[i].seId);

      for (let i = 0; i < obj.email.length; i++)
        obj.emailSelected.push(obj.email[i].seId);

      for(let i = 0;i<obj.tasks.length;i++)
      {
        obj.selectedTasks.push(obj.tasks[i].taskID);
      }
      if (obj.res.length > 0) {
        for (let i = 0; i < obj.res.length; i++) {
          const x = {
            srNo: i + 1,
            resourceId: obj.res[i].resourceId,
            isCaptured: obj.res[i].isCaptured,
            isReleased: obj.res[i].isReleased,
          };
          obj.resSelected.push(x);
        }
      } else {
        const x = {
          srNo: 1,
          resourceId: 0,
          isCaptured: false,
          isReleased: false,
        };
        obj.resSelected.push(x);
      }
    },

    stepUpDownArrowClick(ndx, what) {
      debugger;
      let sourceId = 0;
      let sourceSrNo = 0;
      let targetId = 0;
      let targetSrNo = 0;
      console.log()
      console.log(ndx)
      if (what === "up" && ndx > 0) {
        sourceId = this.aSingleStage.steps[ndx].step.stepId;
        targetId = this.aSingleStage.steps[ndx - 1].step.stepId;

        sourceSrNo = this.aSingleStage.steps[ndx - 1].step.srNo;
        targetSrNo = this.aSingleStage.steps[ndx].step.srNo;
        if(sourceSrNo === targetSrNo)
        {
          targetSrNo = targetSrNo+1;
        }
          const id = this.aSingleStage.stageDetail.stage.stageId;
          this.intDummyComm();
          this.dummyComm.extras = this.mixinMakeCommString(
            id,
            sourceId,
            sourceSrNo,
            targetId,
            targetSrNo
          );
          const url = this.SERVER + "/VNSPRAAPI/Stages/UPDSTPSRNO";
          this.axiosGetData(url, 5);
      } else if (what === "down" && ndx < this.aSingleStage.steps.length) {
        sourceId = this.aSingleStage.steps[ndx].step.stepId;
        targetId = this.aSingleStage.steps[ndx + 1].step.stepId;

        sourceSrNo = this.aSingleStage.steps[ndx + 1].step.srNo;
        targetSrNo = this.aSingleStage.steps[ndx].step.srNo;
        if(sourceSrNo === targetSrNo)
        {
          targetSrNo = targetSrNo-1;
        }
          const id = this.aSingleStage.stageDetail.stage.stageId;
          this.intDummyComm();
          this.dummyComm.extras = this.mixinMakeCommString(
            id,
            sourceId,
            sourceSrNo,
            targetId,
            targetSrNo
          );
          const url = this.SERVER + "/VNSPRAAPI/Stages/UPDSTPSRNO";
          this.axiosGetData(url, 5);
      }
      //alert(id);
    
    },

    stageUpDownArrowClick(ndx, what) {
      this.dataChange=true;
      let sourceId = 0;
      let sourceSrNo = 0;
      let targetId = 0;
      let targetSrNo = 0;

      if (what === "up" && ndx > 0) {
        sourceId = this.aStagesList[ndx].stageDetail.stage.stageId;
        targetId = this.aStagesList[ndx - 1].stageDetail.stage.stageId;

        sourceSrNo = this.aStagesList[ndx - 1].stageDetail.stage.srNo;
        targetSrNo = this.aStagesList[ndx].stageDetail.stage.srNo;
      } else if (what === "down" && ndx < this.aStagesList.length) {
        sourceId = this.aStagesList[ndx].stageDetail.stage.stageId;
        targetId = this.aStagesList[ndx + 1].stageDetail.stage.stageId;

        sourceSrNo = this.aStagesList[ndx + 1].stageDetail.stage.srNo;
        targetSrNo = this.aStagesList[ndx].stageDetail.stage.srNo;
      }

      this.intDummyComm();
      this.dummyComm.extras = this.mixinMakeCommString(
        sourceId,
        sourceSrNo,
        targetId,
        targetSrNo
      );
      const url = this.SERVER + "/VNSPRAAPI/Stages/UPDSTGSRNO";
      this.axiosGetData(url, 1);
    },

    archiveStageClick() {
      let arr = [];
      let vm = this;

      for (let i = 0; i < this.aStagesList.length; i++) {
        if (
          this.aStagesList[i].stageDetail.stage.stageId !==
          this.aSingleStage.stageDetail.stage.stageId
        ) {
          let x = {
            id: this.aStagesList[i].stageDetail.stage.stageId,
            name: this.aStagesList[i].stageDetail.stage.name,
          };
          arr.push(x);
        }
      }

      // let x = {
      //   id: 0,
      //   name: "Recycle bin",
      // };

      // arr.push(x);
      // let options = {};
      // $.map(arr, function (o) {
      //   options[o.id] = o.name;
      // });

      Swal.fire({
        title:
          "You are about to Archive " +
          this.aSingleStage.stageDetail.stage.name,
        text: "You have xxx records in this stage. Please select a stage to move them to?",
        // input: "select",
        //inputOptions: options,
      }).then(function (val) {
        if (val) {
          //this.tmp=val;
          if (val.isConfirmed) {
            Swal.fire({
              title: "Are you sure?",
              text: "This can't be undone",
              showConfirmButton: false,
              showDenyButton: true,
              showCancelButton: true,
              denyButtonText: "Yes, Archive it!",
            }).then((result) => {
              if (result.isDenied) {
                vm.intDummyComm();
                vm.dummyComm.extras =
                  vm.aSingleStage.stageDetail.stage.stageId + vm.UKEY;
                const url = vm.SERVER + "/VNSPRAAPI/Stages/ArcStg";
                vm.axiosGetData(url, 4);
              }
            });
          }
        }
      });
    },

    archiveStageClick_1(Id) {
      let arr = [];
      let vm = this;

      for (let i = 0; i < this.aStagesList.length; i++) {
        let x = {
          id: Id,
          name: this.aStagesList[i].stageDetail.stage.name,
        };
        arr.push(x);
      }

      // let x = {
      //   id: 0,
      //   name: "Recycle bin",
      // };

      //arr.push(x);
      //let options = {};
      //$.map(arr, function (o) {
      //  options[o.id] = o.name;
      //});

      Swal.fire({
        title:
          "You are about to Archive " +
          this.aSingleStage.stageDetail.stage.name,
        text: "You have xxx records in this stage. Please select a stage to move them to?",
        //input: "select",
        //inputOptions: options,
      }).then(function (val) {
        if (val) {
          //this.tmp=val;
          if (val.isConfirmed) {
            Swal.fire({
              title: "Are you sure?",
              text: "This can't be undone",
              showConfirmButton: false,
              showDenyButton: true,
              showCancelButton: true,
              denyButtonText: "Yes, Archive it!",
            }).then((result) => {
              if (result.isDenied) {
                vm.intDummyComm();
                vm.dummyComm.extras = Id + vm.UKEY;
                const url = vm.SERVER + "/VNSPRAAPI/Stages/ArcStg";
                vm.axiosGetData(url, 4);
              }
            });
          }
        }
      });
    },

    classObjectStageRes(obj) {
      let x = "bs-label label-warning badgeBorder";
      if (obj.isCaptured) x = "bs-label label-success badgeBorder";
      else if (obj.isReleased) x = "bs-label label-danger badgeBorder";
      return x;
    },

    classObjectStageAlert(obj) {
      let x = "bs-label label-info badgeBorder";
      if (obj.alertDays > 0) x = "bs-label label-success badgeBorder";
      else if (obj.alertHours > 0) x = "bs-label label-warning badgeBorder";
      else if (obj.alertMins > 0) x = "bs-label label-danger badgeBorder";
      return x;
    },

    textObjectStageAlert(obj) {
      let x = "";
      if (obj.alertDays > 0) x = "Dys:" + obj.alertDays + " ";
      if (obj.alertHours > 0) x += "Hrs:" + obj.alertHours + " ";
      if (obj.alertMins > 0) x += "Mins:" + obj.alertMins;
      //alert("-"+x+"-");
      return x;
    },

    editStage(id, ndx) {
      this.dataChanged = false;
      $("#a123").click();
      this.smsSelected = [];
      this.emailSelected = [];
      this.selectedResArr = [];
      this.selectedTasks = [];
      this.editStageId = id;
      this.aSingleStage = JSON.parse(JSON.stringify(this.aStagesList[ndx]));
      this.stepCount = this.aSingleStage.steps.length;

      // initialize existing data
      const obj = this.aSingleStage.stageDetail;
      if (obj.res.length > 0) {
        for (let i = 0; i < obj.res.length; i++) {
          const x = {
            srNo: i + 1,
            resourceId: obj.res[i].resourceId,
            isCaptured: obj.res[i].isCaptured,
            isReleased: obj.res[i].isReleased,
          };
          this.selectedResArr.push(x);
        }
      } else {
        const x = {
          srNo: 1,
          resourceId: 0,
          isCaptured: false,
          isReleased: false,
        };
        this.selectedResArr.push(x);
      }
      //Tasks
      this.selectedTasks = [];
      for (let i = 0; i < obj.tasks.length; i++)
        this.selectedTasks.push(obj.tasks[i].taskID);
        
      //SMS
      this.smsSelected = [];
      for (let i = 0; i < obj.sms.length; i++)
        this.smsSelected.push(obj.sms[i].seId);
      //Email
      this.emailSelected = [];
      for (let i = 0; i < obj.email.length; i++)
        this.emailSelected.push(obj.email[i].seId);
      if (this.aSingleStage.steps && this.aSingleStage.steps.length == 0) {
        this.addNewStep();
      }


      $("#addStage").modal("show");
    },

    updateStageClick() {
      //for stage
      if (this.aSingleStage.stageDetail.stage.name == "") {
        this.ShowWarning("Stage name is require");
        return;
      }
   
      if (
        this.aSingleStage.stageDetail.stage.alertDays > 0 ||
        this.aSingleStage.stageDetail.stage.alertHours > 0 ||
        this.aSingleStage.stageDetail.stage.alertMins > 0 ||
        this.aSingleStage.stageDetail.stage.alertDays < 0 ||
        this.aSingleStage.stageDetail.stage.alertHours < 0 ||
        this.aSingleStage.stageDetail.stage.alertMins < 0
      ) {
        if (
          this.aSingleStage.stageDetail.stage.alertDays < 0 ||
          this.aSingleStage.stageDetail.stage.alertDays > 365
        ) {
          this.ShowWarning("Invalid Days");
          return;
        }
        if (
          this.aSingleStage.stageDetail.stage.alertHours < 0 ||
          this.aSingleStage.stageDetail.stage.alertHours > 24
        ) {
          this.ShowWarning("Invalid Hours");
          return;
        }
        if (
          this.aSingleStage.stageDetail.stage.alertMins < 0 ||
          this.aSingleStage.stageDetail.stage.alertMins > 60
        ) {
          this.ShowWarning("Invalid Minutes");
          return;
        }
      }
      for (let i = 0; i < this.selectedResArr.length; i++) {
        if(i==0)
        {
          if(this.selectedResArr[i].isCaptured==false && this.selectedResArr[i].isReleased==false && this.selectedResArr[i].resourceId!==0)
          {
              this.ShowWarning("Please select resource as capture or release in stage");
              return;
          }
          continue;
        } 
        else if(this.selectedResArr[i].resourceId!=0)
        {          
          if(this.selectedResArr[i].isCaptured==false && this.selectedResArr[i].isReleased==false )
          {
              this.ShowWarning("Please select resource as capture or release in stage");
              return;
          }
        }
        else
        {
           this.ShowWarning("Please select resource in stage");
          return;
        }
      }

      if(this.aSingleStep.resSelected!==undefined){
      for (let i = 0; i < this.aSingleStep.resSelected.length; i++) { 
        if(i==0)
        {
          if(this.aSingleStep.resSelected[i].isCaptured==false && this.aSingleStep.resSelected[i].isReleased==false && this.aSingleStep.resSelected[i].resourceId!==0)
          {
              this.ShowWarning("Please select resource as capture or release in step");
              return;
          }
          continue;
        } 
        else if(this.aSingleStep.resSelected[i].isCaptured==false && this.aSingleStep.resSelected[i].isReleased==false )
        {
            this.ShowWarning("Please select resource as capture or release in step");
            return;
        }
      }
     }

      //for step
      if (this.aSingleStep.step.name !== "") {
        if (this.aSingleStep.step.name == "") {
          this.ShowWarning("Step name is require");
          return;
        }
        if (
          this.aSingleStep.step.alertDays > 0 ||
          this.aSingleStep.step.alertHours > 0 ||
          this.aSingleStep.step.alertMins > 0 ||
          this.aSingleStep.step.alertDays < 0 ||
          this.aSingleStep.step.alertHours < 0 ||
          this.aSingleStep.step.alertMins < 0
        ) {
          if (this.aSingleStep.step.alertDays < 0) {
            this.ShowWarning("Invalid Days");
            return;
          }
          if (this.aSingleStep.step.alertHours < 0) {
            this.ShowWarning("Invalid Hours");
            return;
          }
          if (this.aSingleStep.step.alertMins < 0) {
            this.ShowWarning("Invalid Minutes");
            return;
          }
        }
      }

      //prepare data for step
      //  if (this.editStepIndex >= 0) {
      let obj1 = this.aSingleStep;
      obj1.sms = [];
      obj1.email = [];
      obj1.res = [];
      obj1.tasks = [];

      if (obj1.step.stepId > 0) {
        for (let i = 0; i < obj1.smsSelected.length; i++)
          obj1.sms.push({ seId: obj1.smsSelected[i] });

        for (let i = 0; i < obj1.emailSelected.length; i++)
          obj1.email.push({ seId: obj1.emailSelected[i] });

        for (let i = 0; i < obj1.resSelected.length; i++) {

          obj1.res.push({
            resourceId: obj1.resSelected[i].resourceId,
            isCaptured: obj1.resSelected[i].isCaptured,
            isReleased: obj1.resSelected[i].isReleased,
          });
        }
        for(let i = 0; i < obj1.selectedTasks.length; i++)
        {
          obj1.tasks.push({taskID:obj1.selectedTasks[i] });
        }
      }

      const id = this.aSingleStage.stageDetail.stage.stageId;

      // prepare data for stage
      let obj = this.aSingleStage.stageDetail;
      obj.sms = [];
      obj.email = [];
      obj.res = [];
      obj.tasks =[];
      //add Details here 
      for(let i = 0; i < this.selectedTasks.length;i++)
      {
        obj.tasks.push({ taskID: this.selectedTasks[i]});
      }
      for (let i = 0; i < this.smsSelected.length; i++)
        obj.sms.push({ seId: this.smsSelected[i] });

      for (let i = 0; i < this.emailSelected.length; i++)
        obj.email.push({ seId: this.emailSelected[i] });

      for (let i = 0; i < this.selectedResArr.length; i++) {
        obj.res.push({
          resourceId: this.selectedResArr[i].resourceId,
          isCaptured: this.selectedResArr[i].isCaptured,
          isReleased: this.selectedResArr[i].isReleased,
        });
      }

      $("#UpdSt_btn").prop("disabled", true);
      // now post it
      this.intDummyComm();
      this.dummyComm.extras1 = "StageStep";
      let myData = {
        dc: this.dummyComm,
        stageDetail: this.aSingleStage.stageDetail,
        sd: this.aSingleStep,
      };

      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Stages/UPDSTG",
        data: myData,
        headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          this.myData = res.data;
          this.aStagesList = res.data.stages;
          this.ress = res.data.ress;
          this.smss = res.data.smss;
          this.emails = res.data.emails;

          for (let i = 0; i < this.aStagesList.length; i++)
            if (this.aStagesList[i].stageDetail.stage.stageId === id) {
              this.aSingleStage = JSON.parse(
                JSON.stringify(this.aStagesList[i])
              );
              break;
            }
          createToast("Information Updated", {
            type: "success",
            showIcon: "true",
            transition: "slide",
            timeout: 1500,
          });
          $("#UpdSt_btn").prop("disabled", false);
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          }
        })
        .finally(() => {
          loader.hide();
          this.dataChanged = false;
          this.ResetLogoutTime();
        });
    },

    //show Sms
    showSms(sms) {
      return sms.length < 1 ? "" : sms[0].name;
    },

    removeResToList(ndx) {
      //alert("resoure -");
      // this.dataChanged = true;
      if(this.selectedResArr.length==1)
      {
        return;
      }
      this.selectedResArr.splice(ndx, 1);
    },

    addResToList() {
      //alert("resource");
      //  this.dataChanged = true;
      const x = {
        srNo: 1,
        resourceId: 0,
        isCaptured: false,
        isReleased: false,
      };
      this.selectedResArr.push(x);
    },

    addNewStage() {
      $("#addNewSt_btn").prop("disabled", true);
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Stages/AddStage";
      this.axiosGetData(url, 3).then(() => {
        var data =
          this.aStagesList[this.aStagesList.length - 1].stageDetail.stage
            .stageId;

        window.scrollTo(0, document.body.scrollHeight);
        this.editStage(data, this.aStagesList.length - 1);
      });
    },

    addNewStep() {
      const id = this.aSingleStage.stageDetail.stage.stageId;
      const x = this.aSingleStage.steps.length + 1;
      const newStep = {
        step: {
          stepId: 0,
          stageId: id,
          name: "Step-0" + x,
          alertDays: 0,
          alertHours: 0,
          alertMins: 0,
          srNo: x,
          isDeleted: 0,
        },
        res: [],
        sms: [],
        email: [],
      };

      this.aSingleStep = newStep;
      this.editStepIndex = 0;
      this.changeValue = 1;
      this.addUpdateStep(this.changeValue);
      //this.aSingleStage.steps.push(newStep);
    },

    // *66*
    addUpdateStep(value) {
      if (value == 0) {
        if (this.aSingleStep.step.name == "") {
          this.ShowWarning("Stage name is require");
          return;
        }
        // if (this.aSingleStep.smsSelected.length == 0) {
        //   this.ShowWarning("Sms is require");
        //   return;
        // }
        // if (this.aSingleStep.emailSelected.length == 0) {
        //   this.ShowWarning("Email is require");
        //   return;
        // }
        if (
          this.aSingleStep.step.alertDays > 0 ||
          this.aSingleStep.step.alertHours > 0 ||
          this.aSingleStep.step.alertMins > 0 ||
          this.aSingleStep.step.alertDays < 0 ||
          this.aSingleStep.step.alertHours < 0 ||
          this.aSingleStep.step.alertMins < 0
        ) {
          if (this.aSingleStep.step.alertDays < 0) {
            this.ShowWarning("Invalid Days");
            return;
          }
          if (this.aSingleStep.step.alertHours < 0) {
            this.ShowWarning("Invalid Hours");
            return;
          }
          if (this.aSingleStep.step.alertMins < 0) {
            this.ShowWarning("Invalid Minutes");
            return;
          }
        }
        // else{
        //     this.ShowWarning("Alerts require");
        //     return;
        // }
      }

      if (this.editStepIndex >= 0) {
        let obj = this.aSingleStep;
        obj.sms = [];
        obj.email = [];
        obj.res = [];

        if (obj.step.stepId > 0) {
          for (let i = 0; i < obj.smsSelected.length; i++)
            obj.sms.push({ seId: obj.smsSelected[i] });

          for (let i = 0; i < obj.emailSelected.length; i++)
            obj.email.push({ seId: obj.emailSelected[i] });

          for (let i = 0; i < obj.resSelected.length; i++) {
            obj.res.push({
              resourceId: obj.resSelected[i].resourceId,
              isCaptured: obj.resSelected[i].isCaptured,
              isReleased: obj.resSelected[i].isReleased,
            });
          }
        }

        const id = this.aSingleStage.stageDetail.stage.stageId;
        this.intDummyComm();
        let myData = {
          dc: this.dummyComm,
          sd: this.aSingleStep,
        };
        var loader = this.$loading.show({
          // Optional parameters
          color: "#03a9f3",
        });
        axios({
          method: "post",
          url: this.SERVER + "/VNSPRAAPI/Stages/ADUDSTP",
          data: myData,
          headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
        })
          .then((res) => {
            loader.hide();
            this.dummyComm = res.data.dc;
            if (this.dummyComm.auditFlag == 1) {
             //debugger // eslint-disable-line no-debugger
              this.aStagesList = res.data.stages;
              this.ress = res.data.ress;
              this.smss = res.data.smss;
              this.emails = res.data.emails;

              for (let i = 0; i < this.aStagesList.length; i++)
                if (this.aStagesList[i].stageDetail.stage.stageId === id) {
                  //alert(id);
                  this.aSingleStage = JSON.parse(
                    JSON.stringify(this.aStagesList[i])
                  );
                  break;
                }
              //this.loadInit();
            }
            createToast("Information Updated", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
          })
          .catch(function (error) {
            if (error.response) {
              alert("-> " + error.response.data);
              alert("-> " + error.response.status);
              alert("-> " + error.response.headers);
            } else if (error.request) {
              alert("No response " + error.request);
            }
          })
          .finally(() => {
            this.ResetLogoutTime();
            loader.hide();
          });
      }
    },

    loader_1() {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
    },
    SelectedResourceChange(resourceId)
    {
          
      //alert("Selected resource");      
      this.dataChanged = true;
    },
    EnterName()
    {
      //  alert("Text Change Name");
      this.dataChanged = true;
    },
    MultiSelectListChanged()
    {
      // alert("MultiSelected Name");
      this.dataChanged = true;
    },
    loadInit() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.extras1 = "StageStep";
      const url = this.SERVER + "/VNSPRAAPI/Stages/GTStages";

      this.axiosGetData(url, 1);
      this.StartLogoutTime();
    },

    //------------------------------------------ Common Methods
    async axiosGetData(myUrl, what) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: myUrl,
        data: this.dummyComm,
        headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          // if everything goes well -- we will get data
          this.lastErrorCode = 1;
          if (what === 1) {
           //debugger // eslint-disable-line no-debugger
            this.myData = res.data;
            this.aStagesList = res.data.stages;
            this.ress = res.data.ress;

            this.smss = res.data.smss;
            this.taskList = res.data.tasks;
            this.emails = res.data.emails;
            // let ss=res.data;
            // alert(ss.stages[0]);
          } else if (what === 2) {
            this.demos = res.data.demos;
            this.emails = res.data.emails;
            this.phys = res.data.phys;
            this.quests = res.data.quests;
            this.smss = res.data.smss;
          } else if (what === 3) {
            this.aStagesList = res.data.stages;
            this.ress = res.data.ress;
            this.smss = res.data.smss;
            this.emails = res.data.emails;
          } else if (what === 4) {
            if (res.data.dc.auditFlag < 0) {
              Swal.fire(
                res.data.dc.auditFlag + ": " + res.data.dc.auditFlagVal,
                "",
                "error"
              );
            } else {
              this.aStagesList = res.data.stages;
              this.ress = res.data.ress;
              this.smss = res.data.smss;
              this.emails = res.data.emails;
              $("#addStage").modal("hide");
              Swal.fire("Stage Archived successfully", "", "success");
            }
          } else if (what === 5) {
            const id = this.aSingleStage.stageDetail.stage.stageId;
            this.aStagesList = res.data.stages;
            this.ress = res.data.ress;
            this.smss = res.data.smss;
            this.emails = res.data.emails;
            for (let i = 0; i < this.aStagesList.length; i++)
              if (this.aStagesList[i].stageDetail.stage.stageId === id) {
                //alert(id);
                this.aSingleStage = JSON.parse(
                  JSON.stringify(this.aStagesList[i])
                );
            
              }
          } else if (what === 6) {
           //debugger // eslint-disable-line no-debugger
            const id = this.aSingleStage.stageDetail.stage.stageId;
            this.aStagesList = res.data.stages;
            this.ress = res.data.ress;
            this.smss = res.data.smss;
            this.emails = res.data.emails;
            for (let i = 0; i < this.aStagesList.length; i++)
              if (this.aStagesList[i].stageDetail.stage.stageId === id) {
                //alert(id);
                this.aSingleStage = JSON.parse(
                  JSON.stringify(this.aStagesList[i])
                );
                break;
              }
              this.successToastUpd();

            // const idd = this.aSingleStage.stageDetail.stage.stageId;
            // const x = this.aSingleStage.steps.length + 1;
            // const newStep = {
            //   step: {
            //     stepId: 0,
            //     stageId: idd,
            //     name: "Step-0" + x,
            //     alertDays: 0,
            //     alertHours: 0,
            //     alertMins: 0,
            //     srNo: x,
            //     isDeleted: 0,
            //   },
            //   res: [],
            //   sms: [],
            //   email: [],
            // };
            //this.aSingleStep = newStep;
            this.stepNameClick(this.editStepIndex);
            this.editStepIndex = 0;
          } else if (what === 7) {
           //debugger // eslint-disable-line no-debugger
            this.successToastUpd();
            const id = this.aSingleStage.stageDetail.stage.stageId;
            this.aStagesList = res.data.stages;
            this.ress = res.data.ress;
            this.smss = res.data.smss;
            this.emails = res.data.emails;
            for (let i = 0; i < this.aStagesList.length; i++)
              if (this.aStagesList[i].stageDetail.stage.stageId === id) {
                this.aSingleStage = JSON.parse(
                  JSON.stringify(this.aStagesList[i])
                );
                break;
              }

            // const idd = this.aSingleStage.stageDetail.stage.stageId;
            // const x = this.aSingleStage.steps.length + 1;
            // const newStep = {
            //   step: {
            //     stepId: 0,
            //     stageId: idd,
            //     name: "Step-0" + x,
            //     alertDays: 0,
            //     alertHours: 0,
            //     alertMins: 0,
            //     srNo: x,
            //     isDeleted: 0,
            //   },
            //   res: [],
            //   sms: [],
            //   email: [],
            // };
            //this.aSingleStep = newStep;
            this.stepNameClick(this.editStepIndex);
            this.editStepIndex = 0;
          }
          $("#addNewSt_btn").prop("disabled", false);
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.dataChanged = false;
          this.ResetLogoutTime();
          loader.hide();
        });
    }, // axiosGetData
    closeButton()
    {
      this.dataChanged =false;
    },
    selectedStepResArrChanged(resource, index) {
      debugger;
      let org = this.aSingleStep.resSelected;
      let bak = this.aSingleStep.resSelectedBak;
      let found = false;
      if(resource.resourceId == null || resource.resourceId == 0 )
      {
        resource.resourceId = 0;
        resource.isCaptured = false;
        resource.isReleased = false;
        return;
      }
      for (let i = 0; i < org.length; i++) {
        const res = org.filter((f) => f.resourceId == org[i].resourceId);
        if (res.length > 1) {
          found = true;
          break;
        }
      }
      if (found) {
        this.errorToastUpd("Resource already in the list.");
        resource.resourceId = 0;
        resource.isCaptured = false;
        resource.isReleased = false;
        // for (let i = 0; i < org.length; i++) {
        //   this.aSingleStep.resSelected[i].isCaptured=false;
        //   this.aSingleStep.resSelected[i].isReleased=false;
        //   this.aSingleStep.resSelected[i].resourceId=0;
        // }
        // for (let i = 0; i < bak.length; i++) {
        //    this.dataChanged = true;
        //   this.aSingleStep.resSelected[i].isCaptured=bak[i].isCaptured;
        //   this.aSingleStep.resSelected[i].isReleased=bak[i].isReleased;
        //   this.aSingleStep.resSelected[i].resourceId=bak[i].resourceId;
        // }
        //this.selectedResArr = JSON.parse(JSON.stringify(bak));
      } else {
        this.aSingleStep.resSelectedBak = JSON.parse(JSON.stringify(org));
      }
    },
    selectedStageResArrChanged(resource,index) {
     debugger;
      let org = this.selectedResArr;
      let bak = this.selectedResArrBak;
      let found = false;
      if(resource.resourceId == null)
      {
        resource.resourceId = 0;
        resource.isCaptured = false;
        resource.isReleased = false;
        return;
      }
      for (let i = 0; i < org.length; i++) {
        const res = org.filter((f) => f.resourceId == org[i].resourceId && org[i].resourceId > 0);
        if (res.length > 1) {
          found = true;
          break;
        }
      }
      if (found) {
        this.errorToastUpd("Resource already in the list.");
        resource.resourceId = 0;
        resource.isCaptured = false;
        resource.isReleased = false;
        // for (let i = 0; i < org.length; i++) {
        //   this.selectedResArr[i].isCaptured=false;
        //   this.selectedResArr[i].isReleased=false;
        //   this.selectedResArr[i].resourceId=0;
        // }
        // for (let i = 0; i < bak.length; i++) {
        //   this.dataChanged = true;
        //   this.selectedResArr[i].isCaptured=bak[i].isCaptured;
        //   this.selectedResArr[i].isReleased=bak[i].isReleased;
        //   this.selectedResArr[i].resourceId=bak[i].resourceId;
        // }
        //this.selectedResArr = JSON.parse(JSON.stringify(bak));
      } else {
        this.selectedResArrBak = JSON.parse(JSON.stringify(org));
      }
      
    },
  }, // methods

  mounted() {
    if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
    clearTimeout(this.loadObj);
    this.handleRole();
    this.loadInit();
  }, // mounted
  unmounted() {
    clearTimeout(this.TimerObject);
  },

  watch: {
    pss: function () {
      this.$nextTick(() => {
        $("#table002").DataTable().destroy();
        $("#table002").DataTable({
          scrollY: "300vh",
          scrollX: true,
          scrollCollapse: true,
          pageLength: 10,
          lengthMenu: [
            [10, 25, 50, -1],
            [10, 25, 50, "All"],
          ],
        });

        $(".table002").DataTable().draw();
      }); // this.$nextTick
    },

    smss: function () {
      this.smsList = [];
      for (let i = 0; i < this.smss.length; i++) {
        this.smsList.push({});
        this.smsList[i].value = this.smss[i].smsId;
        this.smsList[i].label = this.smss[i].smsNameShort;
      }
    },

    emails: function () {
      this.emailList = [];
      for (let i = 0; i < this.emails.length; i++) {
        this.emailList.push({});
        this.emailList[i].value = this.emails[i].emailId;
        this.emailList[i].label = this.emails[i].emailNameShort;
      }
    },
  }, // watch
};
</script>


<style>
/* #lefti{
  text-align: left;
  margin-left:6px;
} */
#left {
  margin-left: 6px;
  position: absolute;
}
.addResource {
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-25%);
}

div.b {
  white-space: nowrap;
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: -24px;
  margin-left: 68px;
}

.modal-backdrop {
  z-index: 600 !important;
}
</style>